<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M13,7C13,7,3,7,3,7C2.45,7,2,7.45,2,8C2,8.55,2.45,9,3,9C3,9,13,9,13,9C13.55,9,14,8.55,14,8C14,7.45,13.55,7,13,7C13,7,13,7,13,7Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Minus',
} as DefineComponent
</script>
